import { useI18nStore } from '../../state/i18nStore';
import type { FeatureName } from '../../state/i18nStore';
import type { StringWrapperCtor } from '../../state/types';

import { getFeatureTranslationKey } from './shared';

type UseHaveTranslationsCompleted = (Strings: StringWrapperCtor<unknown>) => boolean;
export const useHaveTranslationsCompleted: UseHaveTranslationsCompleted = (Strings: StringWrapperCtor<unknown>) =>
  useI18nStore((state) => {
    const { translations, currentLocale } = state;

    const featureId = getFeatureTranslationKey(currentLocale, Strings.feature);

    const status = translations[featureId]?.status;

    return status === 'fulfilled' || status === 'rejected';
  });

const defaultRawTranslations = {};

type UseTranslationDataForFeature = (feature: FeatureName) => Record<string, string>;
export const useTranslationDataForFeature: UseTranslationDataForFeature = (feature) =>
  useI18nStore((state) => {
    const { translations, currentLocale, previousLocale } = state;

    const featureTranslations =
      translations[getFeatureTranslationKey(currentLocale, feature)] ||
      translations[getFeatureTranslationKey(previousLocale, feature)];

    return featureTranslations?.status === 'fulfilled' ? featureTranslations.strings : defaultRawTranslations;
  });
